<template>
  <div>
    <el-dialog custom-class="email-log-title-window" :close-on-click-modal="false" :visible.sync="innerVisible" width="544px" :title="$t('Clearing.SendLog')" @close="innerVisible=false">
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'505px',height:'350px'}"
        />
      </div></el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getInvoiceMailHistory } from '@/api/clearing/invoice'

export default {
  name: 'EmailLogTitleWindow',
  props: {
    visible: { type: Boolean, required: true },
    invoiceKey: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Time'), field: 'dateCreated',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }, width: 180
        },
        { headerName: this.$t('Clearing.Sender'), field: 'createdName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_EmailAddress'), field: 'mailTo', width: 200 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  mounted() {

  },
  methods: {
    toQuery() {
      if (!this.invoiceKey) {
        this.$message.warning(this.$t('Clearing.InvoiceUuidCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      getInvoiceMailHistory({ 'keys': [this.invoiceKey] }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
